import { Paper, Stack, Typography } from '@mui/material';
import { RenderBarProps } from './ContractPhasesDataRows';
import { Period } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';
import { VyIcon } from '@vy/ui-design-system';
import { formatDate, formatPeriodMonths } from '../../../../../../utils/date';
import { VyTooltip } from '../../../../../../components/new-design/VyTooltip';

export const ContractPhasesRowBar: React.FC<RenderBarProps> = ({ color, width, height, periodData }) => {
  const { period, icon, title, color: overrideColor, backgroundColor } = periodData;

  const colorToUse = overrideColor ?? color;
  const backgroundColorToUse = backgroundColor ?? `${colorToUse}50`;

  return (
    <div
      style={{
        backgroundColor: `white`,
        width: `${width}px`,
        height: `${height}px`,
        borderLeft: `4px solid ${colorToUse}`,
        borderRadius: '0 8px 8px 0',
      }}
    >
      <div
        style={{
          backgroundColor: backgroundColorToUse,
          borderRadius: '0 8px 8px 0',
          width: `100%`,
          height: `100%`,
        }}
        className="p-2 flex items-start justify-center flex-col"
      >
        <VyTooltip
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: 'transparent',
              },
            },
          }}
          tooltipContent={
            <Paper sx={{ padding: '16px', width: '240px', height: '110px' }}>
              <Stack direction={'column'} sx={{
                gap: 1
              }}>
                <Typography
                  sx={{
                    fontSize: '15px',
                    fontWeight: 600
                  }}>
                  {title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '13px',
                    fontWeight: 400
                  }}>
                  {`Period: ${formatPhasePeriod(period)}`}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '13px',
                    fontWeight: 400
                  }}>
                  {`(${formatPeriodMonths(period)})`}
                </Typography>
              </Stack>
            </Paper>
          }
        >
          <Stack
            direction={'row'}
            sx={{
              width: '100%',
              alignItems: 'center',
              gap: 1
            }}>
            {isNotNullOrUndefined(icon) && (
              <div className="w-6 h-6 flex items-center justify-center">
                <VyIcon color={colorToUse} transform="scale(1.5)" icon={icon}></VyIcon>
              </div>
            )}
            <Stack
              direction={'column'}
              sx={{
                width: '70%',
                height: '100%'
              }}>
              <Typography
                noWrap
                sx={{
                  textOverflow: 'ellipsis',
                  width: '100%',
                  fontSize: '15px',
                  fontWeight: 600
                }}>
                {title}
              </Typography>
              <Typography
                noWrap
                sx={{
                  textOverflow: 'ellipsis',
                  maxHeight: '20px',
                  width: '100%',
                  fontSize: '13px',
                  fontWeight: 400
                }}>
                {formatPhasePeriod(period)}
              </Typography>
            </Stack>
          </Stack>
        </VyTooltip>
      </div>
    </div>
  );
};

function formatPhasePeriod(period: Period) {
  const startString = formatDate(period.startTime, 'MMM DD, YY');
  const endString = formatDate(period.endTime, 'MMM DD, YY');

  return `${startString} - ${endString}`;
}
